import { Creative } from '../../../../lib/components/creative';
import { StoreContext } from '../../../../lib/store';
import styles from './styles.scss';
import { useContext } from 'react';
import classNames from 'classnames';

import * as React from 'react';
import { hexToRGBA } from 'common/js/colors';
import { CreativeHtml } from '../creative-html';

export interface Props {
  displayBlurEffect: boolean;
  isTablet: boolean;
  isFullscreen: boolean;
}

export function Component({
  displayBlurEffect,
  isTablet,
  isFullscreen
}: Props) {
  const store = useContext(StoreContext);
  const isVertical = store.creativeStore.isVertical;

  const {
    creative,
    blurEffect,
    shouldRefreshFrameOnRotation,
    forceResponsiveHtml
  } = store.formatConfig;

  const { smartphonePortrait, tabletPortrait, tabletLandscape } = creative;
  const isImageCreative = creative?.creative === 'Image';

  let creativeContainerStyle: React.CSSProperties = {
    backgroundColor: hexToRGBA(
      creative.backgroundColor || '#FFF',
      (creative.backgroundOpacity || 0) / 100
    )
  };

  const getCreativeImageUrl = () => {
    if (isVertical) return isTablet ? tabletPortrait : smartphonePortrait;
    return isFullscreen || isTablet ? tabletLandscape : smartphonePortrait;
  };

  const getBlurImageUrl = () => {
    if (blurEffect.image?.length > 0) return blurEffect.image;
    return getCreativeImageUrl();
  };

  let creativePosition = creative.position;
  let creativeStyle: React.CSSProperties = {};

  if (creative.creativeCover) {
    creativePosition = 'center';
    creativeStyle = {
      ...creativeStyle,
      height: '100%',
      objectFit: 'cover'
    };
  }

  if (displayBlurEffect) {
    creativePosition = 'center';
    creativeStyle = {
      ...creativeStyle,
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      zIndex: 1
    };
    creativeContainerStyle = {
      ...creativeContainerStyle,
      justifyContent: 'center'
    };
  }

  const getAlignStyle = () => {
    if (creativePosition === 'top') return styles.alignTop;
    if (creativePosition === 'center') return styles.alignCenter;
    return styles.alignBottom;
  };

  return (
    <>
      {isImageCreative ? (
        <Creative
          onClick={e => {
            store.userClickHandler.handle(e);
          }}
          containerClassName={classNames(
            styles.creativeContainer,
            getAlignStyle()
          )}
          creativeUrl={getCreativeImageUrl()}
          containerStyle={creativeContainerStyle}
          imageStyle={creativeStyle}
          blurCreativeUrl={getBlurImageUrl()}
          imageClassName={classNames(styles.creative, getAlignStyle())}
        />
      ) : (
        <CreativeHtml
          onClick={e => store.userClickHandler.handle(e as ClickEvent)}
          shouldRefreshFrameOnRotation={shouldRefreshFrameOnRotation}
          forceResponsiveHtml={forceResponsiveHtml}
          displayBlurEffect={displayBlurEffect}
        />
      )}
    </>
  );
}
